import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'
import {TextField} from 'formik-material-ui'
import SelectField from '../../../../components/SelectField'
import {ESTBLISHMENT_FORMATS} from '../../../../constants'
import {StepHeader} from '../../styles'

const Step4 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Dados da empresa
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              name="legalName"
              label="Razão social"
              helperText="Como está escrito no cartão CNPJ"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="phantasyName"
              label="Nome fantasia"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              label="Natureza Júridica"
              native
              name="establishmentFormat"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              {ESTBLISHMENT_FORMATS.map(({label, value}) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Field
              name="revenue"
              label="Receita anual"
              fullWidth
              component={TextField}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  )
}

export default Step4
